/**
 * GA4 Collection Page Events
 * SelectSortingOption, SelectFilter, ClickProductTile, ClickQuickShop
 * Only runs on collection pages.
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  const route = window.trovelle?.ga4?.route?.getRoute?.();
  if (route?.type !== 'collection') return;

  function getCollectionContext() {
    const resultsList = document.querySelector('results-list[data-collection-name]');
    return {
      collection_name: resultsList?.getAttribute('data-collection-name') || document.title || '',
      result_count: parseInt(resultsList?.getAttribute('data-result-count') || '0', 10),
      page_location: window.location.href,
      page_title: document.title || '',
    };
  }

  function parseFiltersFromParams(params) {
    const filters = {};
    for (const [key, value] of params) {
      if (key.startsWith('filter.') && value) {
        const parts = key.split('.');
        const filterKey = parts[parts.length - 1]?.toLowerCase() || key;
        filters[filterKey] = value;
      }
    }
    return filters;
  }

  function getSortOptionName(sortComponent, value) {
    if (!value) return '';
    const opt = sortComponent?.querySelector(`input[value="${value}"], select option[value="${value}"]`);
    return opt?.getAttribute('data-option-name') || opt?.textContent?.trim() || value;
  }

  function getProductData(card, listItem) {
    const parsePrice = (v) => {
      const n = typeof v === 'string' ? parseFloat(v) : Number(v);
      return isNaN(n) ? 0 : n / 100;
    };
    const productId = card?.getAttribute('data-product-id') || listItem?.getAttribute('data-product-id');
    const position = parseInt(listItem?.getAttribute('data-product-position') || '0', 10);
    let selectedSize = '';
    const sizeBtn = card?.querySelector('.product-card-quick-shop__size-btn--active');
    if (sizeBtn) {
      selectedSize = sizeBtn.textContent?.trim() || '';
    } else {
      const variantInput = card?.querySelector('input[type="radio"]:checked[data-variant-id]');
      if (variantInput) {
        const opt = variantInput.closest('[data-option]') || variantInput.closest('.variant-option');
        selectedSize = opt?.querySelector('.variant-option__button-label, .variant-option__value')?.textContent?.trim() || '';
      }
    }
    const ctx = getCollectionContext();
    const filters = parseFiltersFromParams(new URLSearchParams(window.location.search));
    return {
      product_id: productId || '',
      title: card?.getAttribute('data-product-title') || '',
      vendor_id: card?.getAttribute('data-product-vendor') || '',
      vendor_name: card?.getAttribute('data-product-vendor') || '',
      sku_id: card?.getAttribute('data-product-sku') || '',
      product_type: card?.getAttribute('data-product-type') || '',
      price: parsePrice(card?.getAttribute('data-product-price')),
      color: card?.getAttribute('data-product-color') || '',
      fit: card?.getAttribute('data-product-fit') || '',
      composition: card?.getAttribute('data-product-composition') || '',
      product_position: position,
      selectedSize: selectedSize || '',
      filters,
      ...ctx,
    };
  }

  function init() {
    let previousSorting = '';
    function updatePreviousSorting() {
      const sortComponent = document.querySelector('sorting-filter-component');
      const urlSort = new URL(window.location.href).searchParams.get('sort_by');
      const details = sortComponent?.querySelector('details');
      const defaultSort = details?.dataset?.defaultSortBy || '';
      const selectedInput = sortComponent?.querySelector('input[name="sort_by"]:checked');
      const selectedOpt = sortComponent?.querySelector(`select option[value="${urlSort || defaultSort}"]`);
      previousSorting = selectedInput?.getAttribute('data-option-name') || selectedOpt?.textContent?.trim() || getSortOptionName(sortComponent, urlSort || defaultSort) || 'Featured';
    }
    updatePreviousSorting();

    document.addEventListener('change', (e) => {
      const target = e.target;
      if (target?.name !== 'sort_by') return;
      if (!target.closest('sorting-filter-component')) return;
      let selectedName = '';
      if (target instanceof HTMLSelectElement) {
        selectedName = target.options[target.selectedIndex]?.text?.trim() || target.value;
      } else {
        selectedName = target.getAttribute('data-option-name') || target.value;
      }
      gtag('event', 'SelectSortingOption', {
        previous_sorting: previousSorting,
        selected_sorting: selectedName,
        ...getCollectionContext(),
      });
      previousSorting = selectedName;
    }, true);

    let previousFilters = parseFiltersFromParams(new URLSearchParams(window.location.search));

    document.addEventListener('change', (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;
      if (!input.name?.startsWith('filter.')) return;
      const facetsForm = input.closest('form[id^="FacetFiltersForm"], facets-form-component form');
      if (!facetsForm || !(facetsForm instanceof HTMLFormElement)) return;

      const key = input.name.split('.').pop()?.toLowerCase() || input.name;
      const value = input.value;
      const filters = {};
      facetsForm.querySelectorAll('input[name^="filter."]:checked').forEach((inp) => {
        if (inp instanceof HTMLInputElement) {
          const k = inp.name.split('.').pop()?.toLowerCase() || inp.name;
          filters[k] = inp.value;
        }
      });
      const selectedFilter = { [key]: value };

      const formData = new FormData(facetsForm);
      const newParams = new URLSearchParams(formData);
      newParams.delete('page');
      const newUrl = new URL(window.location.pathname, window.location.origin);
      newParams.forEach((v, k) => newUrl.searchParams.set(k, v));
      const newCtx = getCollectionContext();
      newCtx.page_location = newUrl.toString();

      gtag('event', 'SelectFilter', {
        previous_filters: { ...previousFilters },
        filters: { ...filters },
        selectedFilter,
        ...newCtx,
      });
      previousFilters = { ...filters };
    }, true);

    document.addEventListener('click', (e) => {
      const target = e.target;

      if (target.closest('.product-card-quick-shop__button')) {
        const btn = target.closest('.product-card-quick-shop__button');
        const quickShop = btn?.closest('.product-card-quick-shop');
        const card = quickShop?.closest('product-card') || quickShop?.closest('.product-card');
        const listItem = card?.closest('.product-grid__item');
        if (card && listItem) {
          const link = card.querySelector('a.product-card__link');
          let clickURL = link?.href || '';
          const sizeBtn = quickShop?.querySelector('.product-card-quick-shop__size-btn--active');
          if (sizeBtn?.dataset?.variantId && clickURL) {
            const url = new URL(clickURL);
            url.searchParams.set('variant', sizeBtn.dataset.variantId);
            clickURL = url.toString();
          }
          const data = getProductData(card, listItem);
          gtag('event', 'ClickQuickShop', { ...data, clickURL });
        }
        return;
      }

      const card = target.closest('product-card') || target.closest('.product-card');
      if (!card) return;
      if (target.closest('.product-card-quick-shop')) return;
      if (target.closest('button, input, label, select, [tabindex="0"]')) return;

      const listItem = card.closest('.product-grid__item');
      const link = card.querySelector('a.product-card__link');
      if (!link?.href) return;

      const data = getProductData(card, listItem);
      gtag('event', 'ClickProductTile', { ...data, clickURL: link.href });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
